/**
 * Résolution d'un droit : un ensemble de permissions autorise-t-il une action ?
 * Fonction pure, sans dépendance, utilisable côté API comme côté frontend.
 */
/**
 * Vrai si `granted` contient la permission demandée.
 * Un administrateur plateforme (`isPlatformAdmin`) dispose de toutes les permissions.
 */
export function hasPermission(granted, required, options = {}) {
    if (options.isPlatformAdmin === true) {
        return true;
    }
    const set = granted instanceof Set ? granted : new Set(granted);
    const requiredList = Array.isArray(required) ? required : [required];
    if (requiredList.length === 0) {
        return true;
    }
    return options.requireAll === true
        ? requiredList.every((code) => set.has(code))
        : requiredList.some((code) => set.has(code));
}
/** Union de plusieurs ensembles de permissions, retournée triée. */
export function mergePermissions(...sets) {
    const merged = new Set();
    for (const set of sets) {
        for (const code of set) {
            merged.add(code);
        }
    }
    return [...merged].sort();
}
//# sourceMappingURL=has-permission.js.map